import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.scss'
import { getConfiguration } from './helpers/configuration'
import { App } from './views'

const root = createRoot(document.getElementById('root'))
root.render(<App />)

if (getConfiguration('useDevTools') === "true" || getConfiguration('useDevTools')) {
  import('react-devtools');
}

if (getConfiguration('isDeployed') === 'true' || getConfiguration('isDeployed')) {

  if ('serviceWorker' in navigator && location.protocol === 'https:') {
    window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      // .then(registration => {
      //   console.log('SW registered', registration)
      // }).catch(registrationError => {
      //   console.log('SW registration failed', registrationError)
      // });
    })
  }
    // add Google Tag Mgr
  ;(function(w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', getConfiguration('googleTagManagerId'))

  // end Google Tag Mgr
}

// add LiveChat
;(function(w, d, s) {
  const i = getConfiguration('rightNow')

  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s)
  j.async = true
  j.src = '//' + i + '.widget.custhelp.com/euf/rightnow/RightNow.Client.js'
  f.parentNode.insertBefore(j, f)
  j.addEventListener('load', function() {
    RightNow.Client.Controller.addComponent(
      {
        chat_login_page: '/app/redirect?r=/app/survey&survey=/app/chat/chat_landing',
        instance_id: 'sccl_0',
        module: 'ConditionalChatLink',
        type: 7,
        modal: 'Enabled',
        wait_threshold: 0
      },
      '//' + i + '.widget.custhelp.com/ci/ws/get'
    )
  })
})(window, document, 'script')
// end LiveChat
